import { BlockWrapper, ChildrenBlock, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { useMediaQuery } from '@mui/material';
import apiFetch from '@wordpress/api-fetch';
import { toast } from 'react-hot-toast';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import style from './block.module.scss';
import { AnimatePresence } from 'framer-motion';
import PopupSuccess from './PopupSuccess';
import ParticlesWrapper from './Particles';

const Block = ({ participate, logged = true }) => {
    const isMobile = useMediaQuery(`(max-width : ${style.mobileBreakpoint})`);
    const [disableSubmit, setDisableSubmit] = useState(participate);
    const [resetFields, setResetFields] = useState(false);
    const [showPopupSuccess, setShowPopupSuccess] = useState(false);
    const [userData, setUserData] = useState(null);

    const formHandler = (e) => {
        e.preventDefault();
        let values = new FormData();
        const formElements = e.target.elements;
        const allNames = {};
        for (let i = 0; i < formElements.length; i++) {
            const elmt = formElements[i];

            //check duplicate fields
            if (!allNames[elmt.name]) allNames[elmt.name] = 1;
            else allNames[elmt.name] += 1;
            elmt.name += allNames[elmt.name] === 1 ? '' : allNames[elmt.name];

            if (elmt.tagName !== 'BUTTON') {
                if (elmt.type === 'checkbox') {
                    values.append(elmt.name, elmt.checked ? '1' : '0');
                } else if (elmt.type === 'file') {
                    if (elmt.required !== false || elmt.value !== '') {
                        values.append(elmt.name, elmt.files[0]);
                    }
                } else {
                    if (elmt.required !== false || elmt.value !== '') values.append(elmt.name, elmt.value);
                }
            }
        }

        // let formData = parseFormData(values);
        apiFetch({
            path: 'quiz/v1/submit',
            method: 'POST',
            body: values,
        })
            .then(
                ({ data }) => {
                    setUserData(data);
                    setShowPopupSuccess(true);
                    setDisableSubmit(true);
                    setResetFields(true);
                },
                (err) => {
                    toast.error(err);
                    setResetFields(true);
                },
            )
            .finally(() => {
                setResetFields(false);
            });
    };

    useEffect(() => {
        if (showPopupSuccess) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'visible';
        }
    }, [showPopupSuccess]);

    const handleClose = () => {
        setShowPopupSuccess(false);
    };

    return (
        <BlockWrapper.Div>
            {participate && <div className={style.msgParticipate}>Vous avez déjà participé</div>}
            {logged ? (
                <form className={clsx(style.block, participate && style.disabled)} onSubmit={formHandler}>
                    <ChildrenBlock
                        className={style.formChildren}
                        gutenbergEditorConfig={{
                            allowedBlocks: [
                                'smartfire/quiz-form---input',
                                'smartfire/quiz-form---select',
                                'smartfire/quiz-form---two-columns',
                                'smartfire/quiz-form---submit',
                                'smartfire/quiz-form---file',
                                'smartfire/quiz-form---checkbox',
                            ],
                            template: [['smartfire/quiz-form---input'], ['smartfire/quiz-form---select']],
                            templateLock: false,
                        }}
                        childrenProps={{
                            disableSubmit: disableSubmit,
                            resetFields,
                        }}
                    />
                </form>
            ) : (
                <></>
            )}
            <AnimatePresence>
                {showPopupSuccess && (
                    <>
                        <PopupSuccess close={handleClose} userData={userData} />
                        {!isMobile && <ParticlesWrapper />}
                    </>
                )}
            </AnimatePresence>
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 1,
            content: '',
        }),
        subtitle: smartProps.object.withDefault({
            headingLevel: 2,
            content: '',
        }),
        info: smartProps.string.withDefault(''),
        submitBtnText: smartProps.string.withDefault('Envoyer'),
    },
    setup: {
        title: 'Formulaire - Jeu concours',
    },
});
